import {Component, Input, OnInit} from '@angular/core';
import {EmisorCFEDTO} from '../../../models/dtos/EmisorCFEDTO';
import {AbstractControl, FormGroup} from '@angular/forms';

@Component
({
  selector: 'app-emisor',
  templateUrl: './emisor.component.html',
  styleUrls: ['./emisor.component.scss']
})
export class EmisorComponent implements OnInit
{
  @Input()
  emisorCFEDTO: EmisorCFEDTO;

  @Input()
  parentFormGroup: FormGroup;

  constructor()
  {

  }

  ngOnInit()
  {

  }

  get rutEmisorControl(): AbstractControl
  {
    return this.parentFormGroup.get('rutEmisorControl');
  }

  get razonSocialEmisorControl(): AbstractControl
  {
    return this.parentFormGroup.get('razonSocialEmisorControl');
  }

  get domicilioFiscalEmisorControl(): AbstractControl
  {
    return this.parentFormGroup.get('domicilioFiscalEmisorControl');
  }

  get ciudadEmisorControl(): AbstractControl
  {
    return this.parentFormGroup.get('ciudadEmisorControl');
  }

  get departamentoEmisorControl(): AbstractControl
  {
    return this.parentFormGroup.get('departamentoEmisorControl');
  }

  public hayControlError(control: AbstractControl): boolean
  {
    return (control.invalid && (control.dirty || control.touched) && control.errors.required);
  }

  limpiar(): void
  {
    this.emisorCFEDTO.limpiar();
  }
}
